<div class="d-block confirm-modal">
  <div *ngIf="imageRef" class="modal-image flex-grow-0 flex-shrink-0">
    <ng-container [ngTemplateOutlet]="imageRef"></ng-container>
  </div>
  <ng-container *ngIf="headerContent">
    <div class="confirm-modal-header d-flex align-items-center border-bottom">
      <ng-container *ngIf="headerContent.icon">
        <span class="material-icons fw-bold font-size-18 me-2" aria-hidden="true">{{ headerContent.icon }}</span>
      </ng-container>
      <h5 class="fw-bold mb-0">{{ headerContent.data }}</h5>
    </div>
  </ng-container>

  <div class="d-flex flex-column justify-content-between flex-grow-1 flex-shrink-1">
    <div class="modal-body">
      <ng-container [ngTemplateOutlet]="modalContent" [ngTemplateOutletContext]="{ $implicit: context }"></ng-container>
    </div>
    <div class="modal-footer d-flex justify-content-end">
      <button type="button" class="btn btn-cancel" (click)="close.emit('close')">
        {{ 'confirm.modal.cancel' | translate }}
      </button>
      <button type="button" class="btn btn-confirm" (click)="confirm.emit('confirm')">
        {{ 'confirm.modal.submit' | translate }}
      </button>
    </div>
  </div>
</div>
